const csvTemplate = `month,year,channel,account_group,reference,quantity
1,2025,GT,GT,DE.SC-APD12ALL1,100
1,2025,GT,GT,AU.SC-TPRYDLAERPALL1,100
1,2025,GT,GT,PW.SC-OMW251,200
2,2025,GT,GT,CX.SC-LGMC501,300
2,2025,GT,GT,IF.SC-GTSHCM501,400
2,2025,MT,YOGYA,AU.SC-MVLMDUDALL1,500
2,2025,MT,ALFAMART,AU.SC-MVLMDUDALL1,500`;

export default csvTemplate;
